import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { blogPosts } from "@/lib/data/blog";

const LATEST_POSTS = blogPosts.slice(0, 3);

const BlogTeaserSection = () => {
    const { ref, isVisible } = useScrollAnimation(0.05);

    if (LATEST_POSTS.length === 0) return null;

    return (
        <section ref={ref} className="py-20 md:py-24 bg-slate-50/60">
            <div className="max-w-6xl mx-auto px-6">
                <div
                    className={`flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 transition-all duration-700 ${
                        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                    }`}
                >
                    <div>
                        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/5 border border-primary/10 mb-4">
                            <BookOpen className="w-3.5 h-3.5 text-primary" />
                            <span className="text-xs font-bold tracking-wide text-primary uppercase">
                                From the blog
                            </span>
                        </div>
                        <h2 className="text-3xl md:text-4xl font-extrabold text-primary leading-tight tracking-tight">
                            Guides for the families closing the gap
                        </h2>
                    </div>
                    <Link
                        to="/blog"
                        className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-primary/80 transition-colors"
                    >
                        See all posts
                        <ArrowRight className="w-4 h-4" />
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {LATEST_POSTS.map((post, i) => (
                        <Link
                            key={post.slug}
                            to={`/blog/${post.slug}`}
                            className={`group block bg-white rounded-2xl p-6 ring-1 ring-black/5 shadow-sm hover:shadow-lg hover:-translate-y-0.5 transition-all duration-700 ${
                                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                            }`}
                            style={{ transitionDelay: isVisible ? `${i * 100}ms` : "0ms" }}
                        >
                            <p className="text-xs font-semibold text-slate-500 mb-2">
                                {post.displayDate} · {post.readingTime}
                            </p>
                            <h3 className="text-lg font-bold text-primary leading-snug mb-2 group-hover:underline">
                                {post.title}
                            </h3>
                            <p className="text-sm text-slate-600 leading-relaxed line-clamp-3">
                                {post.excerpt}
                            </p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default BlogTeaserSection;
